import React, { FC } from "react";
import { Form, Stack } from "react-bootstrap";
import { useDisableEnableUserCameraMutation } from "features/api/usersPermissionsManagement/usersPermissionsManagementApiSlice";
import { volunteerData } from "./volunteerTypes";

type Props = {
  volunteer: volunteerData;
};

const DisableCameraCheckBox: FC<Props> = ({ volunteer }) => {
  const [disableEnableUserCamera] = useDisableEnableUserCameraMutation();

  const HandleChangeCheckbox = async (userId: number) => {
    await disableEnableUserCamera({ userId }).unwrap();
  };

  return (
    <Stack direction="horizontal" className="disable-checkbox" gap={0}>
      <Form.Check
        type="switch"
        id="custom-switch"
        checked={volunteer?.userApp?.isEntitledCamera}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          HandleChangeCheckbox(volunteer?.userApp?.id);
        }}
        size={20}
      />
    </Stack>
  );
};

export default DisableCameraCheckBox;
